import React, { useEffect, useState } from "react";
import { Button } from "pepsico-ds";
import { Radio, TextInput } from "pepsico-ds";
import { useDispatch, useSelector } from "react-redux";
import { getProjectDetails } from "../../services/intakeFormService";
import {
  setIntakeProjectDetails,
  setProjectDetails,
  setProjectError,
  setProjectLoading,
} from "../../redux/actions/projectActions";
import { useLocation } from "react-router-dom";
import { CloseOutRadioActions } from "../../redux/closeoutslice/closeOutRadioSlice";
import { Prefix } from "../../utils/fieldConstants";
import RITMRequestView from "./RITMRequest/RITMRequestView";
import { CloseOutActions } from "../../redux/closeoutslice/closeoutSlice";
import AppToaster from "../../shared/appToaster";
import RequestForm from "../RequestForm/RequestForm";
const CloseOutRequest = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [inputValue, setInputValue] = useState(Prefix.RITM);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const loading = useSelector((state: any) => state.project.loading);

  const { isfileUpload, isRITMRequest } = useSelector(
    (state: any) => state.CloseOutRadio
  );
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(CloseOutRadioActions.setisfilUpload(false));
    dispatch(CloseOutRadioActions.setRequestForm(false));
    dispatch(CloseOutRadioActions.setRITMRequest(false));
    dispatch(CloseOutActions.resetAll());
    dispatch(CloseOutActions.setIntakeData({}));
    dispatch(CloseOutActions.resetPreUpload());
    setInputValue("RITM");
    setSelectedOption("");
  }, [location]);

  const handleSelectChange = (value: string) => {
    setSelectedOption(value);
    if (value === "No") {
      dispatch(CloseOutActions.resetAll());
      dispatch(CloseOutActions.resetPreUpload());
      dispatch(setIntakeProjectDetails(null));
      dispatch(CloseOutRadioActions.setisfilUpload(true));
    }
  };
  const handleInputChange = (value: string) => {
    if (
      !value.startsWith(Prefix.RITM) ||
      !/^\d*$/.test(value.slice(Prefix.RITM.length))
    ) {
      setInputValue(Prefix.RITM + " ");
      setTimeout(() => setInputValue(Prefix.RITM), 0);
    } else {
      setInputValue(value);
    }
    setIsButtonEnabled(value.length > 6);
  };

  useEffect(() => {
    if (inputValue.startsWith(Prefix.RITM)) {
      const numericPart = inputValue.slice(4);
      setIsButtonEnabled(numericPart.length >= 2); // Enable button only if at least 2 digits exist
    }
  }, [inputValue]);

  const handlePaste = (e: any) => {
    e.preventDefault();
    // Get pasted data
    const pasteText = e.clipboardData.getData("text");
    // Replace the entire input with "RITM" + valid numbers from pasted content
    if (pasteText.startsWith(Prefix.RITM)) {
      const validSuffix = pasteText.slice(4).replace(/\D/g, ""); // Strip non-numeric characters
      setInputValue(`RITM${validSuffix}`);
    } else {
      setInputValue(Prefix.RITM + " ");
      setTimeout(() => setInputValue(Prefix.RITM), 0); // Default to "RITM" if pasted text is invalid
    }
  };

  const handleInputSubmit = async () => {
    if (inputValue.trim() === "") {
      return; // Prevent submit if RITM number is empty
    }
    dispatch(CloseOutActions.resetPreUpload());
    dispatch(CloseOutActions.resetAll());
    try {
      // Dispatch loading state before API call
      dispatch(setProjectLoading(true));
      const response = await getProjectDetails(inputValue);
      if (response.code === 204 || response.code === 401) {
        // Set the state to show snackbar if no project data is found
        dispatch(setProjectError("No Project Data found!"));
        dispatch(
          CloseOutRadioActions.setSnackBarMessage({
            message:
              response.message ||
              "No project data available for the specific RITM number.",
            severity: response.code === 204 ? "error" : "warning",
          })
        );
      } else if (response.code === 200) {
        dispatch(setProjectDetails(response));
        setInputValue("RITM");
        setSelectedOption("");
        dispatch(CloseOutRadioActions.setRITMRequest(true));
      }
    } catch (error: any) {
      dispatch(setProjectError(error.message || "An error occurred"));
    } finally {
      setTimeout(() => {
        dispatch(setProjectLoading(false));
      }, 1);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {!isfileUpload && !isRITMRequest && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div className="$font-small-medium" style={{ margin: "16px" }}>
            Is there a MyServices Consulting Intake request form already filled
            for this engagement?
          </div>
          <Radio
            helperText=""
            items={["Yes", "No"]}
            reference="radio button"
            showText
            size="large"
            orientation="horizontal"
            onUpdate={(index, value) => handleSelectChange(value)}
            style={{ margin: "16px" }}
          />

          {selectedOption === "Yes" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                margin: "20px 0px 0px 20px",
              }}
            >
              <TextInput
                value={inputValue}
                onChange={(e) => handleInputChange(e.target.value)}
                onPaste={handlePaste}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && isButtonEnabled) {
                    handleInputSubmit();
                  }
                }}
                disabled={loading}
                helperText="Enter the RITM number in the format RITMXXXXX."
                className="ritmInput"
              />
              <Button
                iconTrailing={loading ? "" : "arrow_forward"}
                size="medium"
                text={loading ? "Loading..." : "Submit"}
                variant="primary"
                disabled={!isButtonEnabled || loading}
                onClick={handleInputSubmit}
                style={{ marginTop: "-30px" }}
              />
            </div>
          )}
        </div>
      )}
      <AppToaster/>
      {isfileUpload && !isRITMRequest && <RequestForm />}
      {!isfileUpload && isRITMRequest && (
        <RITMRequestView RITMNumber={inputValue} />
      )}
    </div>
  );
};
export default CloseOutRequest;
